export const APPLICATION = {
  BFF_URL: process.env.REACT_APP_BFF_URL || `http://localhost:8080/api`,
  PUBLIC_URL: process.env.PUBLIC_URL || "/",
  IS_TEST: process.env.NODE_ENV === "test",
  RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY || "",
  TERMS_URL: process.env.REACT_APP_TERMS_URL || "",
};

export const STORAGE = {
  TOKEN_KEY: "auth-token",
  IMPERSONATOR_TOKEN_KEY: "impersonator-auth-token",
};

export const SMALL_SCREEN = 700;

export const PAYMENT = {
  MIN_AMOUNT_PER_ITEM: 10,
  MAX_AMOUNT: 9999999,
};

export const PAGE = {
  LOGIN: () => "/login",
  SIGNUP: () => "/associe-se",
  SIGNUP_CONFIRMATION: () => "/confirmar/:code",
  MONTHLY_PAYMENT_HISTORY: () => "/mensalidades",
  PAY_MONTHLY: () => "/mensalidades/pagar",
  REGISTER_FORM: () => "/cadastro",
  REGISTER_PASSWORD: () => "/cadastro/senha",
  SPONTANEOUS_CONTRIBUTION: () => "/contribuicao-espontanea",
  ADMIN_LOGIN: () => "/admin/login",
  ADMIN_DASHBOARD: () => "/admin/dashboard",
};
